export default __webpack_public_path__ + "static/media/resolved.7e76b364.svg";